import { render, staticRenderFns } from "./Waivers.vue?vue&type=template&id=7475dcf6&scoped=true"
import script from "./Waivers.vue?vue&type=script&lang=js"
export * from "./Waivers.vue?vue&type=script&lang=js"
import style0 from "./Waivers.vue?vue&type=style&index=0&id=7475dcf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7475dcf6",
  null
  
)

export default component.exports